import { useToast } from "vue-toastification";
import axios from "axios";
import config from "@/config";
import cookie from "js-cookie";
import { useUTM } from "./stores/utmStore";
import { captureMessage } from "@/helpers/sentry.js";
import { getSegmentId } from "./helpers/segment/getSegmentId";
import { getQuizSessionId } from "@/helpers/quizSession/getQuizSessionId";
const toast = useToast();

export const HTTP = axios.create({
  baseURL: config.MK_API,
  headers: {
    "api-key": "9df4fa08e2ff50268af2856eb34a79276bf51152c8ffaf429371cdf18c79",
  },
});

// https://hook.eu1.make.com/0m86yo9ehsfcln66536g4vktw62jd7ed

export const quizWebHook = axios.create({
  baseURL: "https://hook.eu1.make.com/",
});

export const BACKOFFICE = axios.create({
  baseURL: config.MK_BACKOFFICE_API,
  headers: {
    "api-key": "9df4fa08e2ff50268af2856eb34a79276bf51152c8ffaf429371cdf18c79",
  },
});

HTTP.interceptors.request.use(
  async function (config) {
    config.headers.common["Accept-Language"] =
      cookie.get("autobookingLang") || cookie.get("client_segment_lang");
    return config;
  },
  function (err) {
    console.log(err.response);
  }
);

HTTP.interceptors.response.use(
  function (response) {
    return response;
  },
  (error) => {
    if (!error.response) return Promise.reject(error);
    console.log(error.response);
    if (error.config && error.config.skipErrorToast) return Promise.reject(error);
    if (
      error.response.status >= 400 &&
      error.response.status !== 404 &&
      error.response.status !== 422
    ) {
      toast.error(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

export default {
  async checkLocalTime(tz_offset, time) {
    try {
      const response = await HTTP.get(
        `/check_local_time/?tz_offset=${tz_offset}&client_time=${time}`
      );
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getSegmentInfo() {
    try {
      const segment = getSegmentId();
      const response = await HTTP.get(`/segments/?id=${segment}`);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  },
  async getAgeInfo() {
    try {
      const segment = getSegmentId();
      const response = await HTTP.get(`/segment_age_rules/?segment=${segment}`);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getTimeslots(date_time, tz_offset, timezone_name, include_fake_slot) {
    try {
      const segment = getSegmentId();

      const paramsObject = {
        date_time: `${date_time}`,
        tz_offset,
        timezone_name,
        segment,
      };
      if (include_fake_slot) paramsObject.include_fake_slot = true;
      const response = await HTTP.get("/auto/timeslots/get_month/", {
        params: paramsObject,
      });
      return response.data;
    } catch (err) {
      return { error: err };
    }
  },
  async checkPhone(phone) {
    try {
      const response = await HTTP.get(`/clients/?phone=${phone}`);
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return false;
      }
    }
  },
  async newClient(data) {
    const pushExistCookie = (names) => {
      names.forEach((name) => {
        if (cookie.get(name)) {
          let nameParameterForServer = "";
          let nameCheckFromCookie = name.split("");
          if (nameCheckFromCookie[0] === "_") {
            nameCheckFromCookie.splice(0, 1);
            nameParameterForServer = nameCheckFromCookie.join("");
          } else nameParameterForServer = name;
          data[nameParameterForServer] = cookie.get(name);
        }
      });
    };

    pushExistCookie(["quiz_id"]);

    const { getCurrentParams, getInitialParams } = useUTM();
    const dataWithUTM = {
      ...data,
      ...getCurrentParams(),
      ...getInitialParams(),
      is_autobooking: true,
    };
    try {
      const response = await HTTP.post("/clients/", dataWithUTM);
      return response.data.id;
    } catch (err) {
      if (err.response.status === 422) {
        return "error";
      }
      console.log(err.response);
    }
  },
  async validatePromocode(promocode) {
    try {
      const response = await HTTP.post(
        "/promocodes/validate/",
        { promocode },
        { skipErrorToast: true }
      );
      return response.data;
    } catch (err) {
      return null;
    }
  },
  async backupForm(data) {
    const pushExistCookie = (names) => {
      names.forEach((name) => {
        if (cookie.get(name)) {
          let nameParameterForServer = "";
          let nameCheckFromCookie = name.split("");
          if (nameCheckFromCookie[0] === "_") {
            nameCheckFromCookie.splice(0, 1);
            nameParameterForServer = nameCheckFromCookie.join("");
          } else nameParameterForServer = name;
          data[nameParameterForServer] = cookie.get(name);
        }
      });
    };
    pushExistCookie(["quiz_id", "referer"]);

    const { getCurrentParams, getInitialParams } = useUTM();
    const dataWithUTM = {
      ...data,
      ...getCurrentParams(),
      ...getInitialParams(),
    };
    try {
      const response = await HTTP.post("/clients/reserve/", dataWithUTM);
      return response.data.id;
    } catch (err) {
      return { error: err };
    }
  },
  async createLead(payload) {
    try {
      const response = await HTTP.post("/leads/", payload);
      return response.data.amocrm_id;
    } catch (err) {
      console.log(err.response);
    }
  },

  async createErrorLead(payload) {
    try {
      const { getCurrentParams, getInitialParams } = useUTM();
      const dataWithUTM = {
        ...payload,
        ...getCurrentParams(),
        ...getInitialParams(),
      };
      
      const ttp = cookie.get('_ttp');
      if (ttp) dataWithUTM.tiktok_pixel = ttp;
  
      const response = await HTTP.post("/landing/non_valid_leads/", dataWithUTM);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
    async createErrorLeadQuiz(payload) {
    try {
      const { getCurrentParams, getInitialParams } = useUTM();
      const dataWithUTM = {
        ...payload,
        ...getCurrentParams(),
        ...getInitialParams(),
      };
      
      const ttp = cookie.get('_ttp');
      if (ttp) dataWithUTM.tiktok_pixel = ttp;
  
      const response = await HTTP.post("/non_valid_client/", dataWithUTM);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getBookingDetail(payload) {
    try {
      const response = await HTTP.get(`/auto/bookings/${payload.id}`);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },
  async getUsersMc() {
    try {
      const response = await HTTP.get(`/bookings_by_client/?client=${cookie.get("client_id")}&in_client_timezone=true`);
      console.log(response.data);
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return false;
      }
    }
  },
  async getRules() {
    const segment = getSegmentId();

    try {
      const response = await HTTP.get(
        `/autobooking_ui_rules/?segment=${segment}`
      );
      console.log(response.data);
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return [];
      }
    }
  },
  async getFaqQuestions() {
    const segment = getSegmentId();

    try {
      const response = await HTTP.get(`/faq_questions/?segment=${segment}`);
      console.log(response.data);
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return [];
      }
    }
  },
  async newBookingV2(payload) {
    try {
      const { getCurrentParams, getInitialParams } = useUTM();
      const dataWithUTM = {
        ...payload,
        ...getCurrentParams(),
        ...getInitialParams(),
      };

      const ttp = cookie.get('_ttp')
      if (ttp) dataWithUTM.tiktok_pixel = ttp

      const response = await HTTP.post("/v2/auto/bookings/", dataWithUTM);
      return response.data.id;
    } catch (err) {
      console.log(`newBookingV2 error`, "PAYLOAD: ", JSON.stringify(payload));
      console.log("--");
      if (err && err.response && err.response.data)
        console.log("ERROR", JSON.stringify(err.response.data));
      captureMessage(`newBookingV2 error`);
      return false;
    }
  },
  async speedTest() {
    try {
      const response = await HTTP.post("/speed_test_string/", {
        string_size: 1,
      });
      return response;
    } catch (err) {
      return false;
    }
  },
  async changeBooking(changingObject, bookingId) {
    return await this.rebookCanceled(changingObject, bookingId);
  },
  async rebookCanceled(changingObject, bookingId) {
    const { mk_starts_at, mk_ends_at, client_time, tz_offset, client_timezone_text, segment_timezone_text } = changingObject;
    const params = { mk_starts_at, mk_ends_at, client_time, tz_offset, client_timezone_text, segment_timezone_text };

    const { getCurrentParams, getInitialParams } = useUTM();
    const dataWithUTM = {
      ...params,
      ...getCurrentParams(),
      ...getInitialParams(),
    };

    try {
      const response = await HTTP.post(`/rescheduling_booking/${bookingId}`, dataWithUTM);
      return response;
    } catch (err) {
      return false;
    }
  },

  async deleteBooking(id) {
    try {
      const response = await HTTP.delete(`/bookings/${id}`);
      return response.data;
    } catch (err) {
      console.log(err.response);
    }
  },

  async sendQuizAnswer(quiz_id, question_rank, text_question, text_answer, financial = false) {
    const segment = getSegmentId();
    const session_id = getQuizSessionId();

    try {
      const response = await HTTP.post("/quiz_answer/", {
        segment,
        session_id,
        quiz_id,
        question_rank,
        text_question,
        text_answer,
        question_type: financial ? "financial" : "default",
        landing_id: cookie.get("landing_id"),
        ga: cookie.get("_ga")
      });
      return response;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  
  async getBookingCount(segment) {
    try {
      const response = await HTTP.get(`/bookings/count/?segment=${segment}`);
      return response.data;
    } catch (err) {
      return { error: true };
    }
  },
};
